(function productCardSlider() {
  if (window.plProductCardsInitialized) return;
  window.plProductCardsInitialized = true;
  const states = new WeakMap();
  const timing = { duration: 420, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' };
  const reducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const wrap = (index, count) => (index % count + count) % count;
  const translate = (distance) => `translate3d(${distance}, 0, 0)`;
  const preload = (slide) => {
    const image = slide.querySelector('img');
    if (!image) return null;
    image.loading = 'eager';
    return image.complete && image.naturalWidth ? null : image.decode?.().catch(() => {});
  };
  const initializeCard = (card) => {
    if (states.has(card)) return states.get(card);
    const slides = [...card.querySelectorAll('[data-pl-card-slide]')];
    const state = { slides, index: Math.max(0, slides.findIndex(slide => !slide.hidden)), busy: false, drag: null, blockClickUntil: 0 };
    states.set(card, state);
    slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== state.index)));
    return state;
  };
  const animatePair = (outgoing, incoming, from, direction, width, commit, finish) => {
    if (reducedMotion() || !outgoing.animate || !incoming.animate) {
      finish();
      return;
    }
    const edge = width ? `${direction * width}px` : `${direction * 100}%`;
    const oppositeEdge = width ? `${-direction * width}px` : `${-direction * 100}%`;
    const animations = [
      outgoing.animate([{ transform: translate(`${from}px`) }, { transform: translate(commit ? oppositeEdge : '0px') }], timing),
      incoming.animate([{ transform: translate(width ? `${from + direction * width}px` : edge) }, { transform: translate(commit ? '0px' : edge) }], timing),
    ];
    Promise.all(animations.map(animation => animation.finished.catch(() => {}))).then(() => {
      finish();
      animations.forEach(animation => animation.cancel());
    });
  };
  const showImage = (card, requestedIndex, direction, drag = null) => {
    const state = initializeCard(card);
    if (state.slides.length < 2 || state.busy) return;
    const next = wrap(requestedIndex, state.slides.length);
    if (next === state.index) return;
    direction ||= next > state.index ? 1 : -1;
    const outgoing = state.slides[state.index];
    const incoming = state.slides[next];
    state.busy = true;
    const start = () => {
      state.index = next;
      incoming.hidden = false;
      outgoing.setAttribute('aria-hidden', 'true');
      incoming.setAttribute('aria-hidden', 'false');
      card.querySelectorAll('[data-pl-card-index]').forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === next)));
      const status = card.querySelector('[data-pl-card-status]');
      if (status) status.textContent = `Image ${next + 1} of ${state.slides.length}`;
      animatePair(outgoing, incoming, drag?.dx || 0, direction, drag?.width || 0, true, () => {
        outgoing.hidden = true;
        outgoing.style.transform = '';
        incoming.style.transform = '';
        state.busy = false;
        preload(state.slides[wrap(next + direction, state.slides.length)]);
      });
    };
    const ready = drag ? null : preload(incoming);
    if (ready) ready.then(start); else start();
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.pl-product-card__image-link');
    const linkedCard = link?.closest('[data-pl-product-card]');
    if (linkedCard && Date.now() < initializeCard(linkedCard).blockClickUntil) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const control = event.target.closest('[data-pl-card-direction], [data-pl-card-index]');
    if (!control) return;
    const card = control.closest('[data-pl-product-card]');
    if (!card) return;
    event.preventDefault();
    const state = initializeCard(card);
    const direction = Number(control.dataset.plCardDirection) || 0;
    showImage(card, control.hasAttribute('data-pl-card-index') ? Number(control.dataset.plCardIndex) : state.index + direction, direction);
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    const controls = event.target.closest('[data-pl-card-controls]');
    if (!controls) return;
    const card = controls.closest('[data-pl-product-card]');
    const state = initializeCard(card);
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    event.preventDefault();
    showImage(card, state.index + direction, direction);
  });
  document.addEventListener('dragstart', (event) => {
    if (event.target.closest('.pl-product-card__image-link')) event.preventDefault();
  });
  document.addEventListener('pointerdown', (event) => {
    const link = event.target.closest('.pl-product-card__image-link');
    if (!link || event.button !== 0 || event.isPrimary === false) return;
    const card = link.closest('[data-pl-product-card]');
    const state = initializeCard(card);
    state.blockClickUntil = 0;
    if (state.busy || state.slides.length < 2) return;
    state.drag = { link, pointerId: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, width: link.getBoundingClientRect().width, started: Date.now(), incoming: null };
  });
  document.addEventListener('pointermove', (event) => {
    const link = event.target.closest('.pl-product-card__image-link');
    if (!link) return;
    const card = link.closest('[data-pl-product-card]');
    const state = states.get(card);
    const drag = state?.drag;
    if (!drag || event.pointerId !== drag.pointerId) return;
    const dx = Math.max(-drag.width, Math.min(drag.width, event.clientX - drag.x));
    const dy = event.clientY - drag.y;
    if (!drag.incoming && Math.max(Math.abs(dx), Math.abs(dy)) < 7) return;
    if (!drag.incoming && Math.abs(dy) > Math.abs(dx)) { state.drag = null; return; }
    event.preventDefault();
    link.setPointerCapture?.(event.pointerId);
    link.setAttribute('data-pl-dragging', '');
    state.blockClickUntil = Date.now() + 700;
    drag.dx = dx;
    drag.direction = dx < 0 ? 1 : -1;
    const incoming = state.slides[wrap(state.index + drag.direction, state.slides.length)];
    if (drag.incoming && drag.incoming !== incoming) {
      drag.incoming.hidden = true;
      drag.incoming.style.transform = '';
    }
    drag.incoming = incoming;
    incoming.hidden = false;
    state.slides[state.index].style.transform = translate(`${dx}px`);
    incoming.style.transform = translate(`${dx + drag.direction * drag.width}px`);
  });
  const endDrag = (event) => {
    const link = event.target.closest('.pl-product-card__image-link');
    if (!link) return;
    const card = link.closest('[data-pl-product-card]');
    const state = states.get(card);
    const drag = state?.drag;
    if (!drag || event.pointerId !== drag.pointerId) return;
    state.drag = null;
    link.removeAttribute('data-pl-dragging');
    if (link.hasPointerCapture?.(event.pointerId)) link.releasePointerCapture(event.pointerId);
    if (!drag.incoming) return;
    state.blockClickUntil = Date.now() + 700;
    const commit = event.type !== 'pointercancel' && (Math.abs(drag.dx) >= Math.min(60, drag.width * .18) || (Math.abs(drag.dx) > 12 && Date.now() - drag.started < 250));
    if (commit) {
      showImage(card, state.index + drag.direction, drag.direction, drag);
    } else {
      state.busy = true;
      const outgoing = state.slides[state.index];
      animatePair(outgoing, drag.incoming, drag.dx, drag.direction, drag.width, false, () => {
        drag.incoming.hidden = true;
        outgoing.style.transform = '';
        drag.incoming.style.transform = '';
        state.busy = false;
      });
    }
  };
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
})();
